import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabrentalsinmumbai() {



  const cardData =
  {
    keyword: 'Luxury Cab Rentals in Mumbai',
    heading: 'Aaryan Travels: Luxury Cab Rentals in Mumbai',
    headingDescription: 'Aaryan Travels offers premium Luxury Cab Rentals in Mumbai for executives, VIP guests, weddings, and leisure travelers who demand elegance and comfort. Whether you need a luxury sedan for a corporate pickup in BKC, a high-end SUV for airport transfers from Chhatrapati Shivaji Maharaj International Airport, or a premium ride for a special event in South Mumbai, our fleet—including Mercedes, BMW, and Innova Crysta—ensures a refined travel experience. With uniformed chauffeurs, plush interiors, and amenities like Wi-Fi and bottled water on request, we deliver a first-class journey across Bandra, Andheri, Navi Mumbai, and Thane. Aaryan Travels is your trusted partner for chauffeur-driven luxury cab rentals in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is Mumbai’s most iconic monument. Initially constructed to commemorate the visit of King George V and Queen Mary, it now serves as a bustling tourist hub. Visitors enjoy ferry rides to Elephanta Caves and stunning sea views. Illuminated beautifully at night, the structure exudes colonial charm. Gateway of India stands as Mumbai’s grand symbol of pride and welcome."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, often called the Queen’s Necklace due to its arched line of streetlights resembling a string of pearls at night, is Mumbai’s most loved promenade. Locals and tourists gather here to enjoy sunsets, cool sea breeze, and street snacks. The sound of crashing waves offers a calming backdrop. It is a perfect place for morning jogs and late-night reflections. Marine Drive is Mumbai’s timeless boulevard of peace and glamour."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is a Victorian Gothic-style railway station built in 1887. Its stained glass windows, stone carvings, and impressive domes make it look like a grand palace. Despite its heritage beauty, it remains one of India’s busiest railway hubs. The station lights up magnificently after dusk. CST is Mumbai’s architectural jewel blending history with daily hustle."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most lively coastal retreat, known for its golden sands and vibrant street food culture. Vendors serve iconic dishes like pav bhaji, bhel puri, and gola ice. Families, joggers, and photographers flock here for sunrise and sunset views. Bollywood celebrities often live nearby, adding to its charm. Juhu Beach is Mumbai’s joyful seaside escape."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet connected by a narrow causeway. At high tide, it appears to float on the sea. Devotees of all faiths visit to seek blessings and listen to soulful qawwali music. The white marble structure glows beautifully in the sun. Haji Ali is Mumbai’s spiritual island of hope and harmony."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, these 5th-century rock-cut caves are dedicated to Lord Shiva. The iconic three-faced Trimurti sculpture is the highlight, representing creation, protection, and destruction. A ferry ride from Gateway of India offers scenic sea views along the way. The caves blend mythology with artistic grandeur. Elephanta Caves are Mumbai’s timeless treasure carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered temples dedicated to Lord Ganesha. Devotees, including celebrities and politicians, visit daily to seek blessings. The idol adorned with gold and flowers radiates divine power. Long queues form especially on Tuesdays. Siddhivinayak is Mumbai’s powerful center of faith and devotion."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai to the western suburbs. Its cable-stayed architecture and sweeping sea views make every drive unforgettable. At night, the bridge is illuminated, creating a futuristic skyline. It has drastically reduced travel time across the coast. The Sea Link is Mumbai’s symbol of innovation and progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant street market filled with shops selling clothing, jewelry, handicrafts, and souvenirs at bargain prices. Popular cafés like Leopold Café and Café Mondegar add a vintage charm. The energy of tourists, vendors, and artists fills the air. Every corner offers something unique to explore. Colaba Causeway is Mumbai’s buzzing bazaar of fashion and culture."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering safaris, trekking trails, and boating. Wildlife enthusiasts can spot deer, monkeys, leopards, and exotic birds. The ancient Kanheri Caves inside the park add a historical touch. It provides a refreshing escape from city life. SGNP is Mumbai’s wild retreat for nature lovers and adventure seekers."
  }
],



"services": [
  {
    "name": "Luxury Cab Rentals in Mumbai",
    "description": "Luxury Cab Rentals in Mumbai provide top-tier vehicles equipped with premium amenities for business, leisure, and special events. The service prioritizes comfort, safety, and punctuality, offering a fleet of luxury sedans, SUVs, and executive cars driven by professional chauffeurs. Whether for airport transfers, corporate travel, or city tours, customers receive a seamless experience with attention to detail and personalized service."
  },
  {
    "name": "Premium Cab Services Mumbai",
    "description": "Premium Cab Services Mumbai offer sophisticated transportation solutions for discerning clients. This service caters to executives and VIPs requiring elegant and reliable travel options, including airport pickups, business meetings, and special occasions. Vehicles are maintained to the highest standards and driven by experienced chauffeurs ensuring discretion and comfort."
  },
  {
    "name": "Chauffeur Driven Luxury Car Mumbai",
    "description": "Chauffeur Driven Luxury Car Mumbai provides exclusive chauffeur services with a fleet of high-end vehicles. The chauffeurs are trained professionals skilled in route management and customer service, guaranteeing a smooth, safe, and luxurious travel experience. This service is perfect for those who want to travel in style without the hassle of driving."
  },
  {
    "name": "Executive Taxi Mumbai",
    "description": "Executive Taxi Mumbai specializes in premium taxi services tailored for business executives and professionals. The taxis feature luxury interiors and amenities that cater to the needs of corporate travelers, including Wi-Fi, refreshments, and privacy features. Punctuality and professionalism are at the core of this service."
  },
  {
    "name": "Corporate Luxury Cab Mumbai",
    "description": "Corporate Luxury Cab Mumbai offers high-end transportation solutions for companies and their clients. The service ensures reliable, timely, and comfortable rides with vehicles that reflect the prestige of the business. Chauffeurs are trained to maintain professionalism and confidentiality during every journey."
  },
  {
    "name": "Wedding Luxury Car Mumbai",
    "description": "Wedding Luxury Car Mumbai delivers elegant and stylish luxury vehicles for weddings and related celebrations. With specially curated fleets including premium sedans, stretch limousines, and luxury SUVs, the service ensures a grand and memorable entrance for the bride, groom, and guests, complemented by courteous and punctual chauffeurs."
  },
  {
    "name": "Best Luxury Cab Mumbai",
    "description": "Best Luxury Cab Mumbai is renowned for its exceptional fleet of vehicles and outstanding customer service. Clients enjoy the latest models, well-maintained cars, and chauffeurs who prioritize safety, comfort, and timely service, making it a preferred choice for luxury travel across Mumbai."
  },
  {
    "name": "Affordable Luxury Cab Mumbai",
    "description": "Affordable Luxury Cab Mumbai combines premium quality with competitive pricing, making luxury transportation accessible for a broader audience. This service offers cost-effective options without compromising on vehicle standards or chauffeur professionalism, ideal for startups, small businesses, and individual travelers."
  },
  {
    "name": "Online Luxury Cab Booking Mumbai",
    "description": "Online Luxury Cab Booking Mumbai streamlines the process of reserving luxury vehicles with a user-friendly digital platform. Customers can easily select vehicle types, schedule rides, and manage bookings with instant confirmations and secure payments, ensuring convenience and transparency."
  },
  {
    "name": "Luxury Sedan Rental Mumbai",
    "description": "Luxury Sedan Rental Mumbai features a wide selection of premium sedans suitable for business travel, special occasions, and leisure trips. These vehicles offer elegant interiors, smooth rides, and state-of-the-art features to enhance the passenger experience."
  },
  {
    "name": "Luxury SUV Hire Mumbai",
    "description": "Luxury SUV Hire Mumbai provides spacious and powerful SUVs perfect for group travel, family outings, and corporate events. The SUVs are equipped with luxury interiors and advanced safety features, ensuring comfort and security on every journey."
  },
  {
    "name": "Elite Car Rentals Mumbai",
    "description": "Elite Car Rentals Mumbai offers exclusive access to a fleet of prestigious cars for those seeking sophistication and class. This service is tailored for clients who desire premium vehicles combined with impeccable service and professionalism."
  },
  {
    "name": "Prestige Taxi Services Mumbai",
    "description": "Prestige Taxi Services Mumbai deliver premium taxi solutions focusing on discretion, luxury, and reliability. Perfect for VIP clients and business travelers who demand high standards and exceptional service quality."
  },
  {
    "name": "Business Class Cab Mumbai",
    "description": "Business Class Cab Mumbai caters to professionals needing consistent and stylish transportation. The service emphasizes punctuality, comfort, and a professional image, with vehicles and drivers meeting corporate standards."
  },
  {
    "name": "High-End Taxi Rentals Mumbai",
    "description": "High-End Taxi Rentals Mumbai provide luxury taxi services with a fleet of upscale vehicles and skilled chauffeurs. This service suits clients seeking exclusivity, comfort, and reliability for both personal and corporate travel."
  }
],
"tableData": [
  ["Luxury Cab Rentals in Mumbai", "Premium Cab Services Mumbai"],
  ["Chauffeur Driven Luxury Car Mumbai", "Executive Taxi Mumbai"],
  ["Corporate Luxury Cab Mumbai", "Wedding Luxury Car Mumbai"],
  ["Best Luxury Cab Mumbai", "Affordable Luxury Cab Mumbai"],
  ["Online Luxury Cab Booking Mumbai", "Luxury Sedan Rental Mumbai"],
  ["Luxury SUV Hire Mumbai", "Elite Car Rentals Mumbai"],
  ["Prestige Taxi Services Mumbai", "Business Class Cab Mumbai"],
  ["High-End Taxi Rentals Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Cab Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury cab rentals in Mumbai, perfect for business trips, special occasions, and airport transfers."
  },
  {
    "WhyChooseheading": "Wide Range of Luxury Vehicles",
    "WhyChoosedescription": "Choose from our fleet of well-maintained luxury cars, including sedans and SUVs, to travel in style and comfort."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers provide courteous, punctual, and safe service to enhance your luxury travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Vehicles",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and hygienic journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive rates covering fuel, tolls, and driver allowances for worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Customize your luxury cab rental with hourly, daily, or long-term options to suit your needs."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service Across Mumbai",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs anywhere in Mumbai for a seamless luxury travel experience."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides premium luxury cab rental services in Mumbai for corporate, personal, and special occasions.',
  },
  {
    question: 'How can I book luxury cab rentals in Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What types of luxury vehicles are available for rental in Mumbai?',
    answer: 'Aaryan Travels offers a fleet of luxury cars including Mercedes-Benz, BMW, Audi, and other premium vehicles in Mumbai.',
  },
  {
    question: 'Are the drivers trained and experienced for luxury cab rentals in Mumbai?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to delivering a top-tier luxury experience.',
  },
  {
    question: 'Can luxury cab rentals in Mumbai be booked for events and airport transfers?',
    answer: 'Yes, our luxury cab rentals are perfect for weddings, corporate events, airport pickups, and VIP travel in Mumbai.',
  },
  {
    question: 'Is the luxury cab rental service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury cab rental services in Mumbai to meet your travel needs anytime.',
  },
  {
    question: 'Are hygiene and safety protocols followed for luxury cab rentals in Mumbai?',
    answer: 'All vehicles are thoroughly sanitized regularly, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for luxury cab rentals in Mumbai?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the luxury cab rental period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Raghav Malhotra',
    feedback: 'Aaryan Travels provided a superb luxury cab rental experience in Mumbai. The car was immaculate and the service flawless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Sharma',
    feedback: 'Highly recommend Aaryan Travels for luxury cab rentals in Mumbai. Professional drivers and excellent service all around.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const luxuryCabMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Rentals in Mumbai",
  "description": "Aaryan Travels offers premium luxury cab rentals in Mumbai. Chauffeur-driven luxury sedans and SUVs for corporate events, weddings, and executive travel at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Luxury Cab Rental Service",
  "keywords": "Luxury Cab Rentals in Mumbai, Premium Cab Services Mumbai, Chauffeur Driven Luxury Car Mumbai, Executive Taxi Mumbai, Corporate Luxury Cab Mumbai, Wedding Luxury Car Mumbai, Best Luxury Cab Mumbai, Affordable Luxury Cab Mumbai, Online Luxury Cab Booking Mumbai, Luxury Sedan Rental Mumbai, Luxury SUV Hire Mumbai, Elite Car Rentals Mumbai, Prestige Taxi Services Mumbai, Business Class Cab Mumbai, High-End Taxi Rentals Mumbai"
};







  return (
    <div>
<Helmet>
  <title>Luxury Cab Rentals in Mumbai | Premium Chauffeur Driven Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury cab rentals in Mumbai with Aaryan Travels. Choose chauffeur-driven premium sedans and SUVs for weddings, corporate travel, and executive rides."
  />
  <meta
    name="keywords"
    content="Luxury Cab Rentals in Mumbai, Premium Cab Services Mumbai, Chauffeur Driven Luxury Car Mumbai, Executive Taxi Mumbai, Corporate Luxury Cab Mumbai, Wedding Luxury Car Mumbai, Best Luxury Cab Mumbai, Affordable Luxury Cab Mumbai, Online Luxury Cab Booking Mumbai, Luxury Sedan Rental Mumbai, Luxury SUV Hire Mumbai, Elite Car Rentals Mumbai, Prestige Taxi Services Mumbai, Business Class Cab Mumbai, High-End Taxi Rentals Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabMumbaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabrentalsinmumbai;